import "@atg-shared/micro-frontend/setPublicPath";
import {initLogger} from "@atg-shared/log";
import {configureStoreForAuthentication} from "@atg-shared/auth";
import {initialiseLanguage} from "@atg-shared/language";
import {configureEmotionCache} from "atg-emotion-cache";
import {store as playStore} from "./store";

initLogger({
    application: "atg-web-play",
    logLevel: process.env.NODE_ENV !== "production" ? "info" : "warn",
});
configureStoreForAuthentication(playStore);
configureEmotionCache("play");

initialiseLanguage(async (locale) => {
    const {messages} = await import(
        /* webpackChunkName: "i18n" */ `../locales/${locale}/messages.po`
    );
    return messages;
});

export const App = () => import(/* webpackChunkName: "App" */ "./components/App");

// VideoFrame is not used anymore, remove it
export const VideoFrame = () =>
    import(/* webpackChunkName: "VideoFrame" */ "@atg-play/mini-player/src");

export const MiniPlayer = () =>
    import(/* webpackChunkName: "VideoFrame" */ "@atg-play/mini-player/src");

export const StartlistArticles = () =>
    import(
        /* webpackChunkName: "StartlistNewsAndInterviews" */ "./components/NewsAndInterviews/NewsAndInterviews"
    );
